/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Compare_Dialogue_ExportInputs */



/**
* | output |
* | --- |
* | "Dialogue List Export (.docx, .csv)" |
*
* @param {Signup_Compare_Dialogue_ExportInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_compare_dialogue_export = /** @type {((inputs?: Signup_Compare_Dialogue_ExportInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Compare_Dialogue_ExportInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Dialogue List Export (.docx, .csv)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Dialogue List Export (.docx, .csv)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Dialogue List Export (.docx, .csv)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Dialogue List Export (.docx, .csv)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Dialogue List Export (.docx, .csv)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Dialogue List Export (.docx, .csv)")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Dialogue List Export (.docx, .csv)")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Dialogue List Export (.docx, .csv)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Dialogue List Export (.docx, .csv)")
	return /** @type {LocalizedString} */ ("Dialogue List Export (.docx, .csv)")
});